import { useEffect } from "react";
import * as nativeEvents from '../Helper/native';
import { useNavigate } from "react-router-dom";

export default function Loading() {
    const navigate = useNavigate();

    useEffect(() => {
        // Capture the token from the URL (if the native app already provided it)
        // so it's available on the home screen, then redirect immediately.
        const url = new URL(window.location.href);
        const tokenHeader = url?.searchParams.get('token');
        const refreshToken = url?.searchParams.get('refreshToken');

        if (tokenHeader) sessionStorage.setItem('AccessToken', tokenHeader);
        if (refreshToken) sessionStorage.setItem('RefreshToken', refreshToken);

        // Also pick up the access token from the native session bridge:
        // synchronously from window.__GOSATS_SESSION__ and via posted messages.
        nativeEvents.getSessionToken();
        const stopSessionListener = nativeEvents.listenForSession();

        window.onpopstate = (e) => {
            console.log(e);
            nativeEvents.goBack();
        };

        // Redirect straight to the home screen. The token is acquired/refreshed
        // in the background by the home screen, so we don't block on a loader.
        navigate(`/home${window.location.search}`, { replace: true });

        return () => {
            stopSessionListener();
        };
    }, [navigate]);

    return <div style={{ height: '100vh', backgroundColor: '#0F0F0F' }} />;
}
